const selectors = {
  accountPages: '[data-account-pages]',
  resetPassword : '[data-recover-link]',
  hideResetPass : '[data-hideResetPass]',
  resetPasswordForm : '[data-recover-password-form]',
  loginForm : '[data-login-form]',
  resetForm: 'form[action="/account/recover"]',
  resetFormBtn: 'form[action="/account/recover"] [data-submit-reset]'
};

class accountPages {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();

    const windowURL = window.location.href;
    const showRecoverForm = windowURL.indexOf('#recover');
    if(showRecoverForm >= 0){
      this.elements.showResetPassword.dispatchEvent(new Event('click'));
    };
    var  field = document.querySelectorAll('input');
    field.forEach(ele=>{
      ele.addEventListener('keyup', function ( event ) {  
        var  key = event.keyCode;
        let currentEle = event.currentTarget;
        let num = currentEle.value;
         num =num.trim().length
          if (num === 0) {
           currentEle.value=''
            event.preventDefault();
             return 
        }
      });
    })
  }

  /**
   * Fecth Selector of login form inputs
   */
  _getElements() {
    const container = document.querySelector(selectors.accountPages);
    return container ? {
      container,
      showResetPassword: document.querySelector(selectors.resetPassword),
      hideResetPass: document.querySelector(selectors.hideResetPass),
      resetPasswordForm: document.querySelector(selectors.resetPasswordForm),
      loginForm: document.querySelector(selectors.loginForm),
      resetForm: document.querySelector(selectors.resetForm),
      resetFormBtn: document.querySelector(selectors.resetFormBtn)
    } : {};
  }

  /**
   * Bind Click events on hide/show password field
   */
  _setupEventListeners() {
      this.elements.showResetPassword.addEventListener('click', this._handleResetPassword.bind(this));
      this.elements.hideResetPass.addEventListener('click', this._handleResetPassword.bind(this));
      // /!\ It was not working anymore so it has been commented
      // this.elements.resetFormBtn.addEventListener('click', this.resetFormValidation.bind(this));
    }
    
  // /!\ It was not working anymore so it is not used anymore
  resetFormValidation(event){
     event.preventDefault();
     let formEmail = document.getElementById('resetCustomerEmail');
     let emailValue = encodeURIComponent(formEmail.value)
     fetch(`/apps/kraken/customer/${emailValue}`).then(response => {
        return response.json();
      }).then(response => {
        
          if(response.status == 'enabled'){
            this.elements.resetForm.submit();
          }else{
            document.querySelector("[data-reset-mes]").innerHTML = response.message;
           
          }
      }).catch((e) => {
          this.elements.resetForm.submit();
      }).finally(() => {
           // this.elements.resetForm.submit();
      });
  }
  
  /**
   * Reset Password
   * @param {event} event 
   */
  _handleResetPassword(event){
      const _this = event.currentTarget;
      if(_this.classList.contains('hide-resetform')){
        // window.location.href = "/account/login#recover";
        this.elements.loginForm.style.display = 'block';
        this.elements.resetPasswordForm.style.display = 'none';
        if(window.location.href.indexOf("#recover") > -1) {
          window.history.replaceState({ }, '', location.href.replace("#recover", ""));
        }
      }else{
        this.elements.loginForm.style.display = 'none';
        this.elements.resetPasswordForm.style.display = 'block';
      }
  }
}

typeof accountPages !== 'undefined' && new accountPages();